import * as React from "react";
import { ChevronDown, type LucideIcon } from "lucide-react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: LucideIcon;
  label: string;
}

/**
 * The library's filter dropdown button (icon, current value, chevron), shared
 * by the channel filter and the Whizzards type filter so the two read as one
 * set. Forwards its ref so it can be a DropdownMenuTrigger `asChild`.
 */
export const FilterTrigger = React.forwardRef<HTMLButtonElement, Props>(
  ({ icon: Icon, label, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className="flex h-9 items-center gap-2 rounded-md border border-input bg-card px-3 text-[13px] font-medium text-foreground hover:bg-accent"
      {...props}
    >
      <Icon size={14} className="shrink-0 text-muted-foreground" />
      <span className="truncate" style={{ maxWidth: 140 }}>
        {label}
      </span>
      <ChevronDown size={14} className="shrink-0 text-muted-foreground" />
    </button>
  ),
);
FilterTrigger.displayName = "FilterTrigger";
